// Мегабайты для текстов о лимитах: одна цифра после запятой, округление вверх — файл на байт
// больше 3 МБ показывается «3,1», а не «3» рядом со словами «до 3 МБ».
export default function formatMb(bytes: number): string {
  return String(Math.ceil((bytes * 10) / 1048576) / 10).replace('.', ',');
}
